import { NavLink } from "react-router-dom";

export default function Sidebar({ open, onClose }: { open?: boolean; onClose?: () => void }) {
  const base = "flex items-center gap-3 px-4 py-3 rounded-xl font-semibold text-[16px] leading-6 tracking-normal font-inter";
  const inactive = `${base} text-[#A3A3A3] hover:bg-white/10`;
  const active = `${base} bg-white/10 text-white`;

  const closeIfMobile = () => onClose?.();

  return (
    <>
      {/* Overlay for mobile */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity ${open ? "block md:hidden" : "hidden"}`}
        onClick={onClose}
      />
      <aside
        className={`
          fixed z-50 top-0 left-0 h-full w-[280px] bg-[#191919]
          flex flex-col overflow-y-auto transition-transform duration-300
          ${open ? "translate-x-0" : "-translate-x-full"}
          md:static md:translate-x-0 md:flex md:block
        `}
        style={{ minWidth: "200px", maxWidth: "100vw" }}
      >
        {/* Content wrapper with padding */}
        <div className="flex flex-col h-full px-7 py-8">
          {/* Close button for mobile - made more visible */}
          <button
            className="absolute top-4 right-4 md:hidden text-white bg-gray-700 rounded-full w-8 h-8 flex items-center justify-center"
            onClick={onClose}
            aria-label="Close sidebar"
          >
            &times;
          </button>

          {/* Top: Logo */}
          <div className="mb-8">
            <img src="/trent_logo.png" alt="Trent Logo" className="mx-auto w-40 h-auto" />
          </div>

          {/* Middle: Navigation */}
          <nav className="flex flex-col gap-2 mb-6">
            {/* Move Command Center to the top */}
            <NavLink
              to="/command-center"
              onClick={closeIfMobile}
              className={({ isActive }) =>
                `${isActive ? active : inactive} sidebar-nav-link${isActive ? " active" : ""}`
              }
            >
              <span>
                <svg className="text-inherit" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2l2.39 7.24h7.61l-6.13 4.47L17.39 22 12 17.76 6.61 22 8.13 13.71 2 9.24h7.61z" />
                </svg>
              </span>
              Command Center
            </NavLink>

            <NavLink
              to="/sales"
              onClick={closeIfMobile}
              className={({ isActive }) =>
                `${isActive ? active : inactive} sidebar-nav-link${isActive ? " active" : ""}`
              }
            >
              <span>
                <svg className="text-inherit" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="3" width="7" height="7" rx="2" />
                  <rect x="14" y="3" width="7" height="7" rx="2" />
                  <rect x="14" y="14" width="7" height="7" rx="2" />
                  <rect x="3" y="14" width="7" height="7" rx="2" />
                </svg>
              </span>
              Sales
            </NavLink>

            <NavLink
              to="/store"
              onClick={closeIfMobile}
              className={({ isActive }) =>
                `${isActive ? active : inactive} sidebar-nav-link${isActive ? " active" : ""}`
              }
            >
              <span>
                <svg className="text-inherit" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="4" y="4" width="16" height="16" rx="2" />
                </svg>
              </span>
              Store
            </NavLink>

            <NavLink
              to="/inventory"
              onClick={closeIfMobile}
              className={({ isActive }) =>
                `${isActive ? active : inactive} sidebar-nav-link${isActive ? " active" : ""}`
              }
            >
              <span>
                <svg className="text-inherit" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M16 17l5-5-5-5M8 7l-5 5 5 5" />
                </svg>
              </span>
              Inventory
            </NavLink>

            <NavLink
              to="/channel"
              onClick={closeIfMobile}
              className={({ isActive }) =>
                `${isActive ? active : inactive} sidebar-nav-link${isActive ? " active" : ""}`
              }
            >
              <span>
                <svg className="text-inherit" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="3" width="18" height="18" rx="2" />
                  <path d="M8 9h8M8 13h6" />
                </svg>
              </span>
              Channel
            </NavLink>

            <NavLink
              to="/summary"
              onClick={closeIfMobile}
              className={({ isActive }) =>
                `${isActive ? active : inactive} sidebar-nav-link${isActive ? " active" : ""}`
              }
            >
              <span>
                <svg className="text-inherit" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="3" width="18" height="18" rx="2" />
                  <path d="M8 9h8M8 13h6" />
                </svg>
              </span>
              Summary
            </NavLink>

            <NavLink
              to="/simulator"
              onClick={closeIfMobile}
              className={({ isActive }) =>
              `${isActive ? active : inactive} sidebar-nav-link${isActive ? " active" : ""}`
              }
            >
              <span>
              <svg className="text-inherit" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="9" />
                <path d="M8 12h8M12 8v8" />
              </svg>
              </span>
              <span className="flex flex-col leading-tight">
              Simulator
              <span className="text-xs text-[#A3A3A3]">Digital Twin</span>
              </span>
            </NavLink>

            <NavLink
              to="/hitl"
              onClick={closeIfMobile}
              className={({ isActive }) =>
              `${isActive ? active : inactive} sidebar-nav-link${isActive ? " active" : ""}`
              }
            >
              <span>
              <svg className="text-inherit" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="9" />
                <path d="M8 12h8M12 8v8" />
              </svg>
              </span>
              <span className="flex flex-col leading-tight">
              HITL
              <span className="text-xs text-[#A3A3A3]">HITL</span>
              </span>
            </NavLink>
          </nav>

          {/* Spacer that grows to push footer to bottom */}
          <div className="flex-grow" />

          {/* Profile section */}
          <div className="flex items-center gap-3 mb-2">
            <img src="./profile_pic.jpg" alt="Profile" className="w-10 h-10 rounded-full object-cover" />
            <div>
              <div className="text-white font-semibold leading-tight">
                {"Yaswanth"}
              </div>
              <div className="text-[#A3A3A3] text-sm">View profile</div>
            </div>
            <button className="ml-auto">
              <svg width="24" height="24" fill="none" stroke="#FFFFFF" strokeWidth="2">
                <circle cx="12" cy="6" r="1.5" />
                <circle cx="12" cy="12" r="1.5" />
                <circle cx="12" cy="18" r="1.5" />
              </svg>
            </button>
          </div>
        </div>
      </aside>
    </>
  );
}